<template>
  <div id="employees">
    <Datatable
      class="datatable"
      entity="employee"
      :parameters="datatableParameters"
      :globalActions="datatableGlobalActions"
      :onRowClick="onRowEdit"
      :rowActions="[{text: 'datatable.edit', method: onRowEdit}]"/>
  </div>
</template>


<script>
  import Datatable from "@/components/Datatable";
  export default {
    name: "employees",

    components: { Datatable },

    data() {
      return {
        queryAtBranchLevel: true,
      }
    },

    computed: {
      branchId() {
        return this.$route.query.branch;
      },
      companyId() {
        return this.$route.query.company;
      },
      datatableParameters() {
        return this.queryAtBranchLevel || !this.companyId
            ? { branch: this.branchId }
            : { company: this.companyId };
      },
      datatableGlobalActions() {
        let actions = [];
        if (this.$store.getters.loggedUserHasModifyPermission) {
          actions.push({text: 'employees.new', method: this.onEmployeeCreate})
        }
        if (this.companyId) {
          actions.push(this.queryAtBranchLevel
              ? {text: 'employees.see_company_employees', method: () => this.queryAtBranchLevel = false}
              : {text: 'employees.see_branches_employees', method: () => this.queryAtBranchLevel = true}
          )
        }
        return actions;
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "employees.title";
      this.$store.state.pageIcon = "/icon/user.svg";
      this.queryAtBranchLevel = !this.companyId;
    },

    methods: {
      onRowEdit(row) {
        let query = Object.assign({}, this.$route.query, { employee: row.id });
        this.$router.push({ path: '/employee/edit', query: query });
      },
      onEmployeeCreate() {
        this.$router.push({ path: '/employee/new', query: this.$route.query });
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>